import { useDeleteArea } from "http-hooks/area/useArea";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteArea({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteArea();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Area"
      description="Are you sure you want to delete this Area? This Area will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
